import { useWindowResize } from '@toggle/helpers';
import { getInstanceByDom, init, registerMap } from 'echarts';
import * as Types from 'echarts/types/dist/echarts';
import React, { useEffect, useRef } from 'react';

import { ThemeName } from '~/design-tokens/themes/themes';

import {
  createApacheConfig,
  DEFAULT_CHART_HEIGHT,
  DEFAULT_CHART_WIDTH,
} from './apache-config';
import { usaData } from './data/usaMap';

export interface ApacheChartProps extends Types.EChartsOption {
  type: string;
  theme?: ThemeName;
}

export const ApacheChart = ({
  theme = 'dark_default',
  type,
  ...options
}: ApacheChartProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { width, height } = useWindowResize({ targetRef: ref });

  useEffect(() => {
    if (ref.current) {
      const chartDom = getInstanceByDom(ref.current);
      chartDom?.resize({ width, height });
    }
  }, [width, height]);

  useEffect(() => {
    if (type === 'apache-us-map') {
      registerMap('USA', usaData as any, {
        Alaska: {
          left: -131,
          top: 25,
          width: 15,
        },
        Hawaii: {
          left: -110,
          top: 28,
          width: 5,
        },
        'Puerto Rico': {
          left: -76,
          top: 26,
          width: 2,
        },
      });
    }

    const chartWidth = ref.current?.clientWidth || DEFAULT_CHART_WIDTH;
    const chartDom = init(ref.current, theme, {
      height: DEFAULT_CHART_HEIGHT,
      width: chartWidth,
    });

    if (Object.keys(options).length) {
      const option = createApacheConfig({
        theme,
        options,
      });
      chartDom.setOption(option);
    }

    return () => {
      chartDom.dispose();
    };
  }, []);

  useEffect(() => {
    if (ref.current) {
      const chartDom = getInstanceByDom(ref.current);
      const option = createApacheConfig({
        theme,
        options,
      });
      chartDom?.setOption(option);
    }
  }, [theme, type, options]);

  return <div ref={ref} />;
};
